<ion-button color="success" size="small" class="button-camera-upload">
	<ion-icon name="camera"></ion-icon>
	<input type="file" accept="image/*" (change)="inputFileSelected($event.target.files)"
		class="input-file-camera-upload" *ngIf="plt === 'browser'">
</ion-button>